// source: signaling_param.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var header_entity_pb = require('./header_entity_pb.js');
goog.object.extend(proto, header_entity_pb);
goog.exportSymbol('proto.himpb.ESig', null, global);
goog.exportSymbol('proto.himpb.ESig.CallRole', null, global);
goog.exportSymbol('proto.himpb.ESig.ControlOption', null, global);
goog.exportSymbol('proto.himpb.ESig.ControlReceipt', null, global);
goog.exportSymbol('proto.himpb.ESig.InviteReceipt', null, global);
goog.exportSymbol('proto.himpb.ESig.MemberRole', null, global);
goog.exportSymbol('proto.himpb.ESig.MemberStatusType', null, global);
goog.exportSymbol('proto.himpb.ESig.RejectReason', null, global);
goog.exportSymbol('proto.himpb.ESig.SessionStatusCode', null, global);
goog.exportSymbol('proto.himpb.ESig.SessionStatusType', null, global);
goog.exportSymbol('proto.himpb.ESig.SessionType', null, global);
goog.exportSymbol('proto.himpb.ESig.SourceType', null, global);
goog.exportSymbol('proto.himpb.SigSessionAcceptParam', null, global);
goog.exportSymbol('proto.himpb.SigSessionCancelParam', null, global);
goog.exportSymbol('proto.himpb.SigSessionCtrlRcpParam', null, global);
goog.exportSymbol('proto.himpb.SigSessionCtrlReqParam', null, global);
goog.exportSymbol('proto.himpb.SigSessionDetail', null, global);
goog.exportSymbol('proto.himpb.SigSessionLeaveParam', null, global);
goog.exportSymbol('proto.himpb.SigSessionRejectParam', null, global);
goog.exportSymbol('proto.himpb.TSigMemberInfo', null, global);
goog.exportSymbol('proto.himpb.TSigSessionControl', null, global);
goog.exportSymbol('proto.himpb.TSigSessionEndRecord', null, global);
goog.exportSymbol('proto.himpb.TSigSessionInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.ESig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.ESig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.ESig.displayName = 'proto.himpb.ESig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TSigSessionEndRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.TSigSessionEndRecord.repeatedFields_, null);
};
goog.inherits(proto.himpb.TSigSessionEndRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TSigSessionEndRecord.displayName = 'proto.himpb.TSigSessionEndRecord';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TSigSessionInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.TSigSessionInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TSigSessionInfo.displayName = 'proto.himpb.TSigSessionInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TSigSessionControl = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.TSigSessionControl, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TSigSessionControl.displayName = 'proto.himpb.TSigSessionControl';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TSigMemberInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.TSigMemberInfo.repeatedFields_, null);
};
goog.inherits(proto.himpb.TSigMemberInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TSigMemberInfo.displayName = 'proto.himpb.TSigMemberInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SigSessionCancelParam = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.SigSessionCancelParam, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SigSessionCancelParam.displayName = 'proto.himpb.SigSessionCancelParam';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SigSessionRejectParam = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.SigSessionRejectParam, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SigSessionRejectParam.displayName = 'proto.himpb.SigSessionRejectParam';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SigSessionAcceptParam = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.SigSessionAcceptParam, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SigSessionAcceptParam.displayName = 'proto.himpb.SigSessionAcceptParam';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SigSessionDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.SigSessionDetail.repeatedFields_, null);
};
goog.inherits(proto.himpb.SigSessionDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SigSessionDetail.displayName = 'proto.himpb.SigSessionDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SigSessionLeaveParam = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.SigSessionLeaveParam, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SigSessionLeaveParam.displayName = 'proto.himpb.SigSessionLeaveParam';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SigSessionCtrlReqParam = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.SigSessionCtrlReqParam, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SigSessionCtrlReqParam.displayName = 'proto.himpb.SigSessionCtrlReqParam';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SigSessionCtrlRcpParam = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.SigSessionCtrlRcpParam, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SigSessionCtrlRcpParam.displayName = 'proto.himpb.SigSessionCtrlRcpParam';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.ESig.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.ESig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.ESig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.ESig.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.ESig}
 */
proto.himpb.ESig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.ESig;
  return proto.himpb.ESig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.ESig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.ESig}
 */
proto.himpb.ESig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.ESig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.ESig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.ESig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.ESig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.himpb.ESig.CallRole = {
  CALLEDUSER: 0,
  CALLER: 1
};

/**
 * @enum {number}
 */
proto.himpb.ESig.MemberRole = {
  GENERAL: 0,
  CREATOR: 1,
  ANCHORMAN: 2,
  AUDIENCE: 4
};

/**
 * @enum {number}
 */
proto.himpb.ESig.SessionType = {
  AUDIO_CALL: 0,
  VIDEO_CALL: 1
};

/**
 * @enum {number}
 */
proto.himpb.ESig.SourceType = {
  FROM_PRI: 0,
  FROM_MULTI: 1,
  FROM_GROUP: 2,
  FROM_CONFERENCE: 4
};

/**
 * @enum {number}
 */
proto.himpb.ESig.SessionStatusType = {
  SESSION_INIT: 0,
  SESSION_CREATED: 1,
  SESSION_CLOSE: 2,
  SESSION_WAITINGJOIN: 3,
  SESSION_ESTABLISHED: 4,
  SESSION_TERMINATED: 5
};

/**
 * @enum {number}
 */
proto.himpb.ESig.SessionStatusCode = {
  SESSIONCODE_DEFAULT: 0,
  SESSIONCODE_END_BY_HANGUP_NORMALLY: 1,
  SESSIONCODE_END_BY_CANCLE_INVIATION: 2,
  SESSIONCODE_END_BY_REFUSE_INVITATION: 3,
  SESSIONCODE_END_BY_INTERRUPT_ABNORMALLY: 4,
  SESSIONCODE_END_BY_TIMEOUT: 5,
  SESSIONCODE_END_BY_USER_FORCE_SHUTDOWN: 6,
  SESSIONCODE_END_BY_SYSTEM_ERROR: 7,
  SESSIONCODE_CLOSE_BY_CLIENT_DETECT_SERVICE_EXCEPTION: 8,
  SESSIONCODE_END_BY_EXPIRE: 9
};

/**
 * @enum {number}
 */
proto.himpb.ESig.InviteReceipt = {
  INVITE_RECEIVED: 0,
  INVITE_ACCEPTED: 1,
  INVITE_REJECTED: 2
};

/**
 * @enum {number}
 */
proto.himpb.ESig.RejectReason = {
  REASON_DEFAULT: 0,
  NO_ANSWERING: 1,
  CURRENTLY_BUSY: 2
};

/**
 * @enum {number}
 */
proto.himpb.ESig.ControlReceipt = {
  CTRL_RECEIVED: 0,
  CTRL_ACCEPTED: 1,
  CTRL_REJECTED: 2
};

/**
 * @enum {number}
 */
proto.himpb.ESig.ControlOption = {
  UNKNOWN_DEV: 0,
  MICROPHONE: 1,
  CAMERA: 2,
  SPEAKER: 3,
  FLASHLIGHT: 4,
  RECORD: 5,
  CAMERA_ZOOM: 6,
  CAMERA_FOCUS: 7,
  HANGUP: 8,
  CAMERA_POSITION: 9,
  ONESELF_MIN: 100,
  ONESELF_WHITEBOARD: 101,
  ONESELF_REALTIME_ANNOTATION: 102,
  ONESELF_FREEZE: 103,
  ONESELF_SLAM_ANNOTATION: 104,
  ONESELF_SCREEN_SHARING: 105,
  ONESELF_MAX: 199
};

/**
 * @enum {number}
 */
proto.himpb.ESig.MemberStatusType = {
  PENDING_INIT: 0,
  PENDING_WAIT_INVITE_ACK: 1,
  PENDING_WAIT_INVITE_ACCEPT: 2,
  PENDING_WAIT_TALK_RESTORE: 10,
  PENDING_MAX: 49,
  INROOM_INIT: 50,
  INROOM_USER_JOIN: 51,
  INROOM_USER_ACCEPT: 52,
  INROOM_USER_TALKING: 53,
  INROOM_USER_HOLD: 54,
  INCHAR_USER_CONTROL: 80,
  INROOM_MAX: 99,
  OUTROOM_INIT: 100,
  OUTROOM_USER_CANCEL: 101,
  OUTROOM_USER_LEAVE: 102,
  OUTROOM_USER_REFUSE: 103,
  OUTROOM_USER_BUSY: 104,
  OUTROOM_USER_DROPLINE: 105,
  OUTROOM_USER_TIMEOUT: 106,
  OUTROOM_USER_MEDIAERR: 107,
  OUTROOM_SYSTEM_CLOSE: 108,
  OUTROOM_SYSTEM_ERR: 109,
  OUTROOM_USER_KICKOUT: 110,
  OUTROOM_MAX: 199
};


/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.TSigSessionEndRecord.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TSigSessionEndRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TSigSessionEndRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TSigSessionEndRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TSigSessionEndRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
    rid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    cid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    idsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    use: jspb.Message.getFieldWithDefault(msg, 5, 0),
    ts: jspb.Message.getFieldWithDefault(msg, 6, 0),
    ev: jspb.Message.getFieldWithDefault(msg, 7, 0),
    code: jspb.Message.getFieldWithDefault(msg, 8, 0),
    source: jspb.Message.getFieldWithDefault(msg, 9, 0),
    srcid: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TSigSessionEndRecord}
 */
proto.himpb.TSigSessionEndRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TSigSessionEndRecord;
  return proto.himpb.TSigSessionEndRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TSigSessionEndRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TSigSessionEndRecord}
 */
proto.himpb.TSigSessionEndRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRid(value);
      break;
    case 2:
      var value = /** @type {!proto.himpb.ESig.SessionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addIds(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUse(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTs(value);
      break;
    case 7:
      var value = /** @type {!proto.himpb.ESig.SessionStatusType} */ (reader.readEnum());
      msg.setEv(value);
      break;
    case 8:
      var value = /** @type {!proto.himpb.ESig.SessionStatusCode} */ (reader.readEnum());
      msg.setCode(value);
      break;
    case 9:
      var value = /** @type {!proto.himpb.ESig.SourceType} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSrcid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TSigSessionEndRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TSigSessionEndRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TSigSessionEndRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TSigSessionEndRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getUse();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getTs();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getEv();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getCode();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getSrcid();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string rid = 1;
 * @return {string}
 */
proto.himpb.TSigSessionEndRecord.prototype.getRid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TSigSessionEndRecord} returns this
 */
proto.himpb.TSigSessionEndRecord.prototype.setRid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ESig.SessionType type = 2;
 * @return {!proto.himpb.ESig.SessionType}
 */
proto.himpb.TSigSessionEndRecord.prototype.getType = function() {
  return /** @type {!proto.himpb.ESig.SessionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.himpb.ESig.SessionType} value
 * @return {!proto.himpb.TSigSessionEndRecord} returns this
 */
proto.himpb.TSigSessionEndRecord.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string cid = 3;
 * @return {string}
 */
proto.himpb.TSigSessionEndRecord.prototype.getCid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TSigSessionEndRecord} returns this
 */
proto.himpb.TSigSessionEndRecord.prototype.setCid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string ids = 4;
 * @return {!Array<string>}
 */
proto.himpb.TSigSessionEndRecord.prototype.getIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.himpb.TSigSessionEndRecord} returns this
 */
proto.himpb.TSigSessionEndRecord.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.himpb.TSigSessionEndRecord} returns this
 */
proto.himpb.TSigSessionEndRecord.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.TSigSessionEndRecord} returns this
 */
proto.himpb.TSigSessionEndRecord.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};


/**
 * optional uint32 use = 5;
 * @return {number}
 */
proto.himpb.TSigSessionEndRecord.prototype.getUse = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSigSessionEndRecord} returns this
 */
proto.himpb.TSigSessionEndRecord.prototype.setUse = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 ts = 6;
 * @return {number}
 */
proto.himpb.TSigSessionEndRecord.prototype.getTs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSigSessionEndRecord} returns this
 */
proto.himpb.TSigSessionEndRecord.prototype.setTs = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional ESig.SessionStatusType ev = 7;
 * @return {!proto.himpb.ESig.SessionStatusType}
 */
proto.himpb.TSigSessionEndRecord.prototype.getEv = function() {
  return /** @type {!proto.himpb.ESig.SessionStatusType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.himpb.ESig.SessionStatusType} value
 * @return {!proto.himpb.TSigSessionEndRecord} returns this
 */
proto.himpb.TSigSessionEndRecord.prototype.setEv = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional ESig.SessionStatusCode code = 8;
 * @return {!proto.himpb.ESig.SessionStatusCode}
 */
proto.himpb.TSigSessionEndRecord.prototype.getCode = function() {
  return /** @type {!proto.himpb.ESig.SessionStatusCode} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.himpb.ESig.SessionStatusCode} value
 * @return {!proto.himpb.TSigSessionEndRecord} returns this
 */
proto.himpb.TSigSessionEndRecord.prototype.setCode = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional ESig.SourceType source = 9;
 * @return {!proto.himpb.ESig.SourceType}
 */
proto.himpb.TSigSessionEndRecord.prototype.getSource = function() {
  return /** @type {!proto.himpb.ESig.SourceType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.himpb.ESig.SourceType} value
 * @return {!proto.himpb.TSigSessionEndRecord} returns this
 */
proto.himpb.TSigSessionEndRecord.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional string srcId = 10;
 * @return {string}
 */
proto.himpb.TSigSessionEndRecord.prototype.getSrcid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TSigSessionEndRecord} returns this
 */
proto.himpb.TSigSessionEndRecord.prototype.setSrcid = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TSigSessionInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TSigSessionInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TSigSessionInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TSigSessionInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    roomkey: jspb.Message.getFieldWithDefault(msg, 3, 0),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    extinfo: jspb.Message.getFieldWithDefault(msg, 5, ""),
    createts: jspb.Message.getFieldWithDefault(msg, 6, 0),
    expirets: jspb.Message.getFieldWithDefault(msg, 7, 0),
    closets: jspb.Message.getFieldWithDefault(msg, 8, 0),
    begints: jspb.Message.getFieldWithDefault(msg, 9, 0),
    endts: jspb.Message.getFieldWithDefault(msg, 10, 0),
    endreason: jspb.Message.getFieldWithDefault(msg, 11, 0),
    creatorid: jspb.Message.getFieldWithDefault(msg, 12, ""),
    creatorname: jspb.Message.getFieldWithDefault(msg, 13, ""),
    source: jspb.Message.getFieldWithDefault(msg, 14, 0),
    srcid: jspb.Message.getFieldWithDefault(msg, 15, ""),
    isvalid: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    status: jspb.Message.getFieldWithDefault(msg, 17, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TSigSessionInfo}
 */
proto.himpb.TSigSessionInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TSigSessionInfo;
  return proto.himpb.TSigSessionInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TSigSessionInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TSigSessionInfo}
 */
proto.himpb.TSigSessionInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.himpb.ESig.SessionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoomkey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtinfo(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatets(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpirets(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setClosets(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBegints(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndts(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setEndreason(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatorid(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatorname(value);
      break;
    case 14:
      var value = /** @type {!proto.himpb.ESig.SourceType} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setSrcid(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsvalid(value);
      break;
    case 17:
      var value = /** @type {!proto.himpb.ESig.SessionStatusType} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TSigSessionInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TSigSessionInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TSigSessionInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TSigSessionInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRoomkey();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getExtinfo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreatets();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getExpirets();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getClosets();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getBegints();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getEndts();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getEndreason();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = message.getCreatorid();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCreatorname();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getSrcid();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getIsvalid();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
};


/**
 * optional ESig.SessionType type = 1;
 * @return {!proto.himpb.ESig.SessionType}
 */
proto.himpb.TSigSessionInfo.prototype.getType = function() {
  return /** @type {!proto.himpb.ESig.SessionType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.himpb.ESig.SessionType} value
 * @return {!proto.himpb.TSigSessionInfo} returns this
 */
proto.himpb.TSigSessionInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.himpb.TSigSessionInfo.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TSigSessionInfo} returns this
 */
proto.himpb.TSigSessionInfo.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 roomKey = 3;
 * @return {number}
 */
proto.himpb.TSigSessionInfo.prototype.getRoomkey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSigSessionInfo} returns this
 */
proto.himpb.TSigSessionInfo.prototype.setRoomkey = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.himpb.TSigSessionInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TSigSessionInfo} returns this
 */
proto.himpb.TSigSessionInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string extInfo = 5;
 * @return {string}
 */
proto.himpb.TSigSessionInfo.prototype.getExtinfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TSigSessionInfo} returns this
 */
proto.himpb.TSigSessionInfo.prototype.setExtinfo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 createTs = 6;
 * @return {number}
 */
proto.himpb.TSigSessionInfo.prototype.getCreatets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSigSessionInfo} returns this
 */
proto.himpb.TSigSessionInfo.prototype.setCreatets = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 expireTs = 7;
 * @return {number}
 */
proto.himpb.TSigSessionInfo.prototype.getExpirets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSigSessionInfo} returns this
 */
proto.himpb.TSigSessionInfo.prototype.setExpirets = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 closeTs = 8;
 * @return {number}
 */
proto.himpb.TSigSessionInfo.prototype.getClosets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSigSessionInfo} returns this
 */
proto.himpb.TSigSessionInfo.prototype.setClosets = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 beginTs = 9;
 * @return {number}
 */
proto.himpb.TSigSessionInfo.prototype.getBegints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSigSessionInfo} returns this
 */
proto.himpb.TSigSessionInfo.prototype.setBegints = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 endTs = 10;
 * @return {number}
 */
proto.himpb.TSigSessionInfo.prototype.getEndts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSigSessionInfo} returns this
 */
proto.himpb.TSigSessionInfo.prototype.setEndts = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional uint32 endReason = 11;
 * @return {number}
 */
proto.himpb.TSigSessionInfo.prototype.getEndreason = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSigSessionInfo} returns this
 */
proto.himpb.TSigSessionInfo.prototype.setEndreason = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string creatorId = 12;
 * @return {string}
 */
proto.himpb.TSigSessionInfo.prototype.getCreatorid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TSigSessionInfo} returns this
 */
proto.himpb.TSigSessionInfo.prototype.setCreatorid = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string creatorName = 13;
 * @return {string}
 */
proto.himpb.TSigSessionInfo.prototype.getCreatorname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TSigSessionInfo} returns this
 */
proto.himpb.TSigSessionInfo.prototype.setCreatorname = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional ESig.SourceType source = 14;
 * @return {!proto.himpb.ESig.SourceType}
 */
proto.himpb.TSigSessionInfo.prototype.getSource = function() {
  return /** @type {!proto.himpb.ESig.SourceType} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.himpb.ESig.SourceType} value
 * @return {!proto.himpb.TSigSessionInfo} returns this
 */
proto.himpb.TSigSessionInfo.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional string srcId = 15;
 * @return {string}
 */
proto.himpb.TSigSessionInfo.prototype.getSrcid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TSigSessionInfo} returns this
 */
proto.himpb.TSigSessionInfo.prototype.setSrcid = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional bool isValid = 16;
 * @return {boolean}
 */
proto.himpb.TSigSessionInfo.prototype.getIsvalid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.TSigSessionInfo} returns this
 */
proto.himpb.TSigSessionInfo.prototype.setIsvalid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional ESig.SessionStatusType status = 17;
 * @return {!proto.himpb.ESig.SessionStatusType}
 */
proto.himpb.TSigSessionInfo.prototype.getStatus = function() {
  return /** @type {!proto.himpb.ESig.SessionStatusType} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.himpb.ESig.SessionStatusType} value
 * @return {!proto.himpb.TSigSessionInfo} returns this
 */
proto.himpb.TSigSessionInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TSigSessionControl.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TSigSessionControl.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TSigSessionControl} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TSigSessionControl.toObject = function(includeInstance, msg) {
  var f, obj = {
    op: jspb.Message.getFieldWithDefault(msg, 1, 0),
    onoff: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    uvalue: jspb.Message.getFieldWithDefault(msg, 3, 0),
    svalue: jspb.Message.getFieldWithDefault(msg, 4, ""),
    fvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TSigSessionControl}
 */
proto.himpb.TSigSessionControl.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TSigSessionControl;
  return proto.himpb.TSigSessionControl.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TSigSessionControl} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TSigSessionControl}
 */
proto.himpb.TSigSessionControl.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.himpb.ESig.ControlOption} */ (reader.readEnum());
      msg.setOp(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnoff(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUvalue(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSvalue(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFvalue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TSigSessionControl.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TSigSessionControl.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TSigSessionControl} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TSigSessionControl.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOp();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getOnoff();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getUvalue();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getSvalue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFvalue();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
};


/**
 * optional ESig.ControlOption op = 1;
 * @return {!proto.himpb.ESig.ControlOption}
 */
proto.himpb.TSigSessionControl.prototype.getOp = function() {
  return /** @type {!proto.himpb.ESig.ControlOption} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.himpb.ESig.ControlOption} value
 * @return {!proto.himpb.TSigSessionControl} returns this
 */
proto.himpb.TSigSessionControl.prototype.setOp = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bool onoff = 2;
 * @return {boolean}
 */
proto.himpb.TSigSessionControl.prototype.getOnoff = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.TSigSessionControl} returns this
 */
proto.himpb.TSigSessionControl.prototype.setOnoff = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional uint32 uValue = 3;
 * @return {number}
 */
proto.himpb.TSigSessionControl.prototype.getUvalue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSigSessionControl} returns this
 */
proto.himpb.TSigSessionControl.prototype.setUvalue = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string sValue = 4;
 * @return {string}
 */
proto.himpb.TSigSessionControl.prototype.getSvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TSigSessionControl} returns this
 */
proto.himpb.TSigSessionControl.prototype.setSvalue = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional float fValue = 5;
 * @return {number}
 */
proto.himpb.TSigSessionControl.prototype.getFvalue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSigSessionControl} returns this
 */
proto.himpb.TSigSessionControl.prototype.setFvalue = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.TSigMemberInfo.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TSigMemberInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TSigMemberInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TSigMemberInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TSigMemberInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rolemask: jspb.Message.getFieldWithDefault(msg, 2, 0),
    memberid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    devicetype: jspb.Message.getFieldWithDefault(msg, 4, 0),
    status: jspb.Message.getFieldWithDefault(msg, 5, 0),
    nowts: jspb.Message.getFieldWithDefault(msg, 6, 0),
    createts: jspb.Message.getFieldWithDefault(msg, 7, 0),
    expirets: jspb.Message.getFieldWithDefault(msg, 8, 0),
    controlsList: jspb.Message.toObjectList(msg.getControlsList(),
    proto.himpb.TSigSessionControl.toObject, includeInstance),
    appid: jspb.Message.getFieldWithDefault(msg, 10, ""),
    contact: (f = msg.getContact()) && header_entity_pb.TContactInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TSigMemberInfo}
 */
proto.himpb.TSigMemberInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TSigMemberInfo;
  return proto.himpb.TSigMemberInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TSigMemberInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TSigMemberInfo}
 */
proto.himpb.TSigMemberInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRolemask(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDevicetype(value);
      break;
    case 5:
      var value = /** @type {!proto.himpb.ESig.MemberStatusType} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNowts(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCreatets(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExpirets(value);
      break;
    case 9:
      var value = new proto.himpb.TSigSessionControl;
      reader.readMessage(value,proto.himpb.TSigSessionControl.deserializeBinaryFromReader);
      msg.addControls(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 11:
      var value = new header_entity_pb.TContactInfo;
      reader.readMessage(value,header_entity_pb.TContactInfo.deserializeBinaryFromReader);
      msg.setContact(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TSigMemberInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TSigMemberInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TSigMemberInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TSigMemberInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRolemask();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getMemberid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDevicetype();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getNowts();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getCreatets();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getExpirets();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getControlsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.himpb.TSigSessionControl.serializeBinaryToWriter
    );
  }
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getContact();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      header_entity_pb.TContactInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string roomId = 1;
 * @return {string}
 */
proto.himpb.TSigMemberInfo.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TSigMemberInfo} returns this
 */
proto.himpb.TSigMemberInfo.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 roleMask = 2;
 * @return {number}
 */
proto.himpb.TSigMemberInfo.prototype.getRolemask = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSigMemberInfo} returns this
 */
proto.himpb.TSigMemberInfo.prototype.setRolemask = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string memberId = 3;
 * @return {string}
 */
proto.himpb.TSigMemberInfo.prototype.getMemberid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TSigMemberInfo} returns this
 */
proto.himpb.TSigMemberInfo.prototype.setMemberid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 deviceType = 4;
 * @return {number}
 */
proto.himpb.TSigMemberInfo.prototype.getDevicetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSigMemberInfo} returns this
 */
proto.himpb.TSigMemberInfo.prototype.setDevicetype = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional ESig.MemberStatusType status = 5;
 * @return {!proto.himpb.ESig.MemberStatusType}
 */
proto.himpb.TSigMemberInfo.prototype.getStatus = function() {
  return /** @type {!proto.himpb.ESig.MemberStatusType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.himpb.ESig.MemberStatusType} value
 * @return {!proto.himpb.TSigMemberInfo} returns this
 */
proto.himpb.TSigMemberInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int64 nowTs = 6;
 * @return {number}
 */
proto.himpb.TSigMemberInfo.prototype.getNowts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSigMemberInfo} returns this
 */
proto.himpb.TSigMemberInfo.prototype.setNowts = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 createTs = 7;
 * @return {number}
 */
proto.himpb.TSigMemberInfo.prototype.getCreatets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSigMemberInfo} returns this
 */
proto.himpb.TSigMemberInfo.prototype.setCreatets = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 expireTs = 8;
 * @return {number}
 */
proto.himpb.TSigMemberInfo.prototype.getExpirets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TSigMemberInfo} returns this
 */
proto.himpb.TSigMemberInfo.prototype.setExpirets = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * repeated TSigSessionControl controls = 9;
 * @return {!Array<!proto.himpb.TSigSessionControl>}
 */
proto.himpb.TSigMemberInfo.prototype.getControlsList = function() {
  return /** @type{!Array<!proto.himpb.TSigSessionControl>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.himpb.TSigSessionControl, 9));
};


/**
 * @param {!Array<!proto.himpb.TSigSessionControl>} value
 * @return {!proto.himpb.TSigMemberInfo} returns this
*/
proto.himpb.TSigMemberInfo.prototype.setControlsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.himpb.TSigSessionControl=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TSigSessionControl}
 */
proto.himpb.TSigMemberInfo.prototype.addControls = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.himpb.TSigSessionControl, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.TSigMemberInfo} returns this
 */
proto.himpb.TSigMemberInfo.prototype.clearControlsList = function() {
  return this.setControlsList([]);
};


/**
 * optional string appId = 10;
 * @return {string}
 */
proto.himpb.TSigMemberInfo.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TSigMemberInfo} returns this
 */
proto.himpb.TSigMemberInfo.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional TContactInfo contact = 11;
 * @return {?proto.himpb.TContactInfo}
 */
proto.himpb.TSigMemberInfo.prototype.getContact = function() {
  return /** @type{?proto.himpb.TContactInfo} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.TContactInfo, 11));
};


/**
 * @param {?proto.himpb.TContactInfo|undefined} value
 * @return {!proto.himpb.TSigMemberInfo} returns this
*/
proto.himpb.TSigMemberInfo.prototype.setContact = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.TSigMemberInfo} returns this
 */
proto.himpb.TSigMemberInfo.prototype.clearContact = function() {
  return this.setContact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.TSigMemberInfo.prototype.hasContact = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SigSessionCancelParam.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SigSessionCancelParam.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SigSessionCancelParam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SigSessionCancelParam.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    roomkey: jspb.Message.getFieldWithDefault(msg, 2, 0),
    requestid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    offlineenabled: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    custominfo: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SigSessionCancelParam}
 */
proto.himpb.SigSessionCancelParam.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SigSessionCancelParam;
  return proto.himpb.SigSessionCancelParam.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SigSessionCancelParam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SigSessionCancelParam}
 */
proto.himpb.SigSessionCancelParam.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoomkey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOfflineenabled(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustominfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SigSessionCancelParam.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SigSessionCancelParam.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SigSessionCancelParam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SigSessionCancelParam.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoomkey();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOfflineenabled();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getCustominfo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string roomId = 1;
 * @return {string}
 */
proto.himpb.SigSessionCancelParam.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionCancelParam} returns this
 */
proto.himpb.SigSessionCancelParam.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 roomKey = 2;
 * @return {number}
 */
proto.himpb.SigSessionCancelParam.prototype.getRoomkey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SigSessionCancelParam} returns this
 */
proto.himpb.SigSessionCancelParam.prototype.setRoomkey = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string requestId = 3;
 * @return {string}
 */
proto.himpb.SigSessionCancelParam.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionCancelParam} returns this
 */
proto.himpb.SigSessionCancelParam.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool offlineEnabled = 4;
 * @return {boolean}
 */
proto.himpb.SigSessionCancelParam.prototype.getOfflineenabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.SigSessionCancelParam} returns this
 */
proto.himpb.SigSessionCancelParam.prototype.setOfflineenabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string customInfo = 5;
 * @return {string}
 */
proto.himpb.SigSessionCancelParam.prototype.getCustominfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionCancelParam} returns this
 */
proto.himpb.SigSessionCancelParam.prototype.setCustominfo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SigSessionRejectParam.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SigSessionRejectParam.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SigSessionRejectParam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SigSessionRejectParam.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    roomkey: jspb.Message.getFieldWithDefault(msg, 2, 0),
    requestid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    inviterid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    inviteeuserid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    reason: jspb.Message.getFieldWithDefault(msg, 6, 0),
    offlineenabled: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    custominfo: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SigSessionRejectParam}
 */
proto.himpb.SigSessionRejectParam.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SigSessionRejectParam;
  return proto.himpb.SigSessionRejectParam.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SigSessionRejectParam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SigSessionRejectParam}
 */
proto.himpb.SigSessionRejectParam.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoomkey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviterid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteeuserid(value);
      break;
    case 6:
      var value = /** @type {!proto.himpb.ESig.RejectReason} */ (reader.readEnum());
      msg.setReason(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOfflineenabled(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustominfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SigSessionRejectParam.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SigSessionRejectParam.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SigSessionRejectParam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SigSessionRejectParam.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoomkey();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getInviterid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getInviteeuserid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getReason();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getOfflineenabled();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getCustominfo();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string roomId = 1;
 * @return {string}
 */
proto.himpb.SigSessionRejectParam.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionRejectParam} returns this
 */
proto.himpb.SigSessionRejectParam.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 roomKey = 2;
 * @return {number}
 */
proto.himpb.SigSessionRejectParam.prototype.getRoomkey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SigSessionRejectParam} returns this
 */
proto.himpb.SigSessionRejectParam.prototype.setRoomkey = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string requestId = 3;
 * @return {string}
 */
proto.himpb.SigSessionRejectParam.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionRejectParam} returns this
 */
proto.himpb.SigSessionRejectParam.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string inviterId = 4;
 * @return {string}
 */
proto.himpb.SigSessionRejectParam.prototype.getInviterid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionRejectParam} returns this
 */
proto.himpb.SigSessionRejectParam.prototype.setInviterid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string inviteeUserId = 5;
 * @return {string}
 */
proto.himpb.SigSessionRejectParam.prototype.getInviteeuserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionRejectParam} returns this
 */
proto.himpb.SigSessionRejectParam.prototype.setInviteeuserid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional ESig.RejectReason reason = 6;
 * @return {!proto.himpb.ESig.RejectReason}
 */
proto.himpb.SigSessionRejectParam.prototype.getReason = function() {
  return /** @type {!proto.himpb.ESig.RejectReason} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.himpb.ESig.RejectReason} value
 * @return {!proto.himpb.SigSessionRejectParam} returns this
 */
proto.himpb.SigSessionRejectParam.prototype.setReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional bool offlineEnabled = 7;
 * @return {boolean}
 */
proto.himpb.SigSessionRejectParam.prototype.getOfflineenabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.SigSessionRejectParam} returns this
 */
proto.himpb.SigSessionRejectParam.prototype.setOfflineenabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string customInfo = 8;
 * @return {string}
 */
proto.himpb.SigSessionRejectParam.prototype.getCustominfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionRejectParam} returns this
 */
proto.himpb.SigSessionRejectParam.prototype.setCustominfo = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SigSessionAcceptParam.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SigSessionAcceptParam.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SigSessionAcceptParam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SigSessionAcceptParam.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    roomkey: jspb.Message.getFieldWithDefault(msg, 2, 0),
    requestid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    inviterid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    inviteeuserid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    offlineenabled: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    custominfo: jspb.Message.getFieldWithDefault(msg, 7, ""),
    autojoin: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    joincustominfo: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SigSessionAcceptParam}
 */
proto.himpb.SigSessionAcceptParam.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SigSessionAcceptParam;
  return proto.himpb.SigSessionAcceptParam.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SigSessionAcceptParam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SigSessionAcceptParam}
 */
proto.himpb.SigSessionAcceptParam.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoomkey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviterid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteeuserid(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOfflineenabled(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustominfo(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutojoin(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setJoincustominfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SigSessionAcceptParam.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SigSessionAcceptParam.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SigSessionAcceptParam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SigSessionAcceptParam.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoomkey();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getInviterid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getInviteeuserid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOfflineenabled();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getCustominfo();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAutojoin();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getJoincustominfo();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string roomId = 1;
 * @return {string}
 */
proto.himpb.SigSessionAcceptParam.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionAcceptParam} returns this
 */
proto.himpb.SigSessionAcceptParam.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 roomKey = 2;
 * @return {number}
 */
proto.himpb.SigSessionAcceptParam.prototype.getRoomkey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SigSessionAcceptParam} returns this
 */
proto.himpb.SigSessionAcceptParam.prototype.setRoomkey = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string requestId = 3;
 * @return {string}
 */
proto.himpb.SigSessionAcceptParam.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionAcceptParam} returns this
 */
proto.himpb.SigSessionAcceptParam.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string inviterId = 4;
 * @return {string}
 */
proto.himpb.SigSessionAcceptParam.prototype.getInviterid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionAcceptParam} returns this
 */
proto.himpb.SigSessionAcceptParam.prototype.setInviterid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string inviteeUserId = 5;
 * @return {string}
 */
proto.himpb.SigSessionAcceptParam.prototype.getInviteeuserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionAcceptParam} returns this
 */
proto.himpb.SigSessionAcceptParam.prototype.setInviteeuserid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool offlineEnabled = 6;
 * @return {boolean}
 */
proto.himpb.SigSessionAcceptParam.prototype.getOfflineenabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.SigSessionAcceptParam} returns this
 */
proto.himpb.SigSessionAcceptParam.prototype.setOfflineenabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string customInfo = 7;
 * @return {string}
 */
proto.himpb.SigSessionAcceptParam.prototype.getCustominfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionAcceptParam} returns this
 */
proto.himpb.SigSessionAcceptParam.prototype.setCustominfo = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool autoJoin = 8;
 * @return {boolean}
 */
proto.himpb.SigSessionAcceptParam.prototype.getAutojoin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.SigSessionAcceptParam} returns this
 */
proto.himpb.SigSessionAcceptParam.prototype.setAutojoin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string joinCustomInfo = 9;
 * @return {string}
 */
proto.himpb.SigSessionAcceptParam.prototype.getJoincustominfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionAcceptParam} returns this
 */
proto.himpb.SigSessionAcceptParam.prototype.setJoincustominfo = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.SigSessionDetail.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SigSessionDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SigSessionDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SigSessionDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SigSessionDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    info: (f = msg.getInfo()) && proto.himpb.TSigSessionInfo.toObject(includeInstance, f),
    membersList: jspb.Message.toObjectList(msg.getMembersList(),
    proto.himpb.TSigMemberInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SigSessionDetail}
 */
proto.himpb.SigSessionDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SigSessionDetail;
  return proto.himpb.SigSessionDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SigSessionDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SigSessionDetail}
 */
proto.himpb.SigSessionDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.himpb.TSigSessionInfo;
      reader.readMessage(value,proto.himpb.TSigSessionInfo.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 2:
      var value = new proto.himpb.TSigMemberInfo;
      reader.readMessage(value,proto.himpb.TSigMemberInfo.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SigSessionDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SigSessionDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SigSessionDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SigSessionDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.himpb.TSigSessionInfo.serializeBinaryToWriter
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.himpb.TSigMemberInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional TSigSessionInfo info = 1;
 * @return {?proto.himpb.TSigSessionInfo}
 */
proto.himpb.SigSessionDetail.prototype.getInfo = function() {
  return /** @type{?proto.himpb.TSigSessionInfo} */ (
    jspb.Message.getWrapperField(this, proto.himpb.TSigSessionInfo, 1));
};


/**
 * @param {?proto.himpb.TSigSessionInfo|undefined} value
 * @return {!proto.himpb.SigSessionDetail} returns this
*/
proto.himpb.SigSessionDetail.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SigSessionDetail} returns this
 */
proto.himpb.SigSessionDetail.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SigSessionDetail.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated TSigMemberInfo members = 2;
 * @return {!Array<!proto.himpb.TSigMemberInfo>}
 */
proto.himpb.SigSessionDetail.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.himpb.TSigMemberInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.himpb.TSigMemberInfo, 2));
};


/**
 * @param {!Array<!proto.himpb.TSigMemberInfo>} value
 * @return {!proto.himpb.SigSessionDetail} returns this
*/
proto.himpb.SigSessionDetail.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.himpb.TSigMemberInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TSigMemberInfo}
 */
proto.himpb.SigSessionDetail.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.himpb.TSigMemberInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SigSessionDetail} returns this
 */
proto.himpb.SigSessionDetail.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SigSessionLeaveParam.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SigSessionLeaveParam.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SigSessionLeaveParam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SigSessionLeaveParam.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    roomkey: jspb.Message.getFieldWithDefault(msg, 2, 0),
    offlineenabled: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    custominfo: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SigSessionLeaveParam}
 */
proto.himpb.SigSessionLeaveParam.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SigSessionLeaveParam;
  return proto.himpb.SigSessionLeaveParam.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SigSessionLeaveParam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SigSessionLeaveParam}
 */
proto.himpb.SigSessionLeaveParam.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoomkey(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOfflineenabled(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustominfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SigSessionLeaveParam.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SigSessionLeaveParam.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SigSessionLeaveParam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SigSessionLeaveParam.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoomkey();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getOfflineenabled();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getCustominfo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string roomId = 1;
 * @return {string}
 */
proto.himpb.SigSessionLeaveParam.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionLeaveParam} returns this
 */
proto.himpb.SigSessionLeaveParam.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 roomKey = 2;
 * @return {number}
 */
proto.himpb.SigSessionLeaveParam.prototype.getRoomkey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SigSessionLeaveParam} returns this
 */
proto.himpb.SigSessionLeaveParam.prototype.setRoomkey = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool offlineEnabled = 3;
 * @return {boolean}
 */
proto.himpb.SigSessionLeaveParam.prototype.getOfflineenabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.SigSessionLeaveParam} returns this
 */
proto.himpb.SigSessionLeaveParam.prototype.setOfflineenabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string customInfo = 4;
 * @return {string}
 */
proto.himpb.SigSessionLeaveParam.prototype.getCustominfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionLeaveParam} returns this
 */
proto.himpb.SigSessionLeaveParam.prototype.setCustominfo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SigSessionCtrlReqParam.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SigSessionCtrlReqParam.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SigSessionCtrlReqParam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SigSessionCtrlReqParam.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    roomkey: jspb.Message.getFieldWithDefault(msg, 2, 0),
    controlreqid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    controluserid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    controlleduserid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    control: (f = msg.getControl()) && proto.himpb.TSigSessionControl.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SigSessionCtrlReqParam}
 */
proto.himpb.SigSessionCtrlReqParam.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SigSessionCtrlReqParam;
  return proto.himpb.SigSessionCtrlReqParam.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SigSessionCtrlReqParam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SigSessionCtrlReqParam}
 */
proto.himpb.SigSessionCtrlReqParam.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoomkey(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setControlreqid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setControluserid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlleduserid(value);
      break;
    case 6:
      var value = new proto.himpb.TSigSessionControl;
      reader.readMessage(value,proto.himpb.TSigSessionControl.deserializeBinaryFromReader);
      msg.setControl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SigSessionCtrlReqParam.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SigSessionCtrlReqParam.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SigSessionCtrlReqParam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SigSessionCtrlReqParam.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoomkey();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getControlreqid();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getControluserid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getControlleduserid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getControl();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.himpb.TSigSessionControl.serializeBinaryToWriter
    );
  }
};


/**
 * optional string roomId = 1;
 * @return {string}
 */
proto.himpb.SigSessionCtrlReqParam.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionCtrlReqParam} returns this
 */
proto.himpb.SigSessionCtrlReqParam.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 roomKey = 2;
 * @return {number}
 */
proto.himpb.SigSessionCtrlReqParam.prototype.getRoomkey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SigSessionCtrlReqParam} returns this
 */
proto.himpb.SigSessionCtrlReqParam.prototype.setRoomkey = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 controlReqId = 3;
 * @return {number}
 */
proto.himpb.SigSessionCtrlReqParam.prototype.getControlreqid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SigSessionCtrlReqParam} returns this
 */
proto.himpb.SigSessionCtrlReqParam.prototype.setControlreqid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string controlUserId = 4;
 * @return {string}
 */
proto.himpb.SigSessionCtrlReqParam.prototype.getControluserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionCtrlReqParam} returns this
 */
proto.himpb.SigSessionCtrlReqParam.prototype.setControluserid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string controlledUserId = 5;
 * @return {string}
 */
proto.himpb.SigSessionCtrlReqParam.prototype.getControlleduserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionCtrlReqParam} returns this
 */
proto.himpb.SigSessionCtrlReqParam.prototype.setControlleduserid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional TSigSessionControl control = 6;
 * @return {?proto.himpb.TSigSessionControl}
 */
proto.himpb.SigSessionCtrlReqParam.prototype.getControl = function() {
  return /** @type{?proto.himpb.TSigSessionControl} */ (
    jspb.Message.getWrapperField(this, proto.himpb.TSigSessionControl, 6));
};


/**
 * @param {?proto.himpb.TSigSessionControl|undefined} value
 * @return {!proto.himpb.SigSessionCtrlReqParam} returns this
*/
proto.himpb.SigSessionCtrlReqParam.prototype.setControl = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SigSessionCtrlReqParam} returns this
 */
proto.himpb.SigSessionCtrlReqParam.prototype.clearControl = function() {
  return this.setControl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SigSessionCtrlReqParam.prototype.hasControl = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SigSessionCtrlRcpParam.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SigSessionCtrlRcpParam.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SigSessionCtrlRcpParam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SigSessionCtrlRcpParam.toObject = function(includeInstance, msg) {
  var f, obj = {
    receipt: jspb.Message.getFieldWithDefault(msg, 1, 0),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    roomkey: jspb.Message.getFieldWithDefault(msg, 3, 0),
    controlreqid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    controluserid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    controlleduserid: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SigSessionCtrlRcpParam}
 */
proto.himpb.SigSessionCtrlRcpParam.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SigSessionCtrlRcpParam;
  return proto.himpb.SigSessionCtrlRcpParam.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SigSessionCtrlRcpParam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SigSessionCtrlRcpParam}
 */
proto.himpb.SigSessionCtrlRcpParam.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.himpb.ESig.ControlReceipt} */ (reader.readEnum());
      msg.setReceipt(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoomkey(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setControlreqid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setControluserid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setControlleduserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SigSessionCtrlRcpParam.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SigSessionCtrlRcpParam.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SigSessionCtrlRcpParam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SigSessionCtrlRcpParam.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceipt();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRoomkey();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getControlreqid();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getControluserid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getControlleduserid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional ESig.ControlReceipt receipt = 1;
 * @return {!proto.himpb.ESig.ControlReceipt}
 */
proto.himpb.SigSessionCtrlRcpParam.prototype.getReceipt = function() {
  return /** @type {!proto.himpb.ESig.ControlReceipt} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.himpb.ESig.ControlReceipt} value
 * @return {!proto.himpb.SigSessionCtrlRcpParam} returns this
 */
proto.himpb.SigSessionCtrlRcpParam.prototype.setReceipt = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.himpb.SigSessionCtrlRcpParam.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionCtrlRcpParam} returns this
 */
proto.himpb.SigSessionCtrlRcpParam.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 roomKey = 3;
 * @return {number}
 */
proto.himpb.SigSessionCtrlRcpParam.prototype.getRoomkey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SigSessionCtrlRcpParam} returns this
 */
proto.himpb.SigSessionCtrlRcpParam.prototype.setRoomkey = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 controlReqId = 4;
 * @return {number}
 */
proto.himpb.SigSessionCtrlRcpParam.prototype.getControlreqid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SigSessionCtrlRcpParam} returns this
 */
proto.himpb.SigSessionCtrlRcpParam.prototype.setControlreqid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string controlUserId = 5;
 * @return {string}
 */
proto.himpb.SigSessionCtrlRcpParam.prototype.getControluserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionCtrlRcpParam} returns this
 */
proto.himpb.SigSessionCtrlRcpParam.prototype.setControluserid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string controlledUserId = 6;
 * @return {string}
 */
proto.himpb.SigSessionCtrlRcpParam.prototype.getControlleduserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigSessionCtrlRcpParam} returns this
 */
proto.himpb.SigSessionCtrlRcpParam.prototype.setControlleduserid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


goog.object.extend(exports, proto.himpb);
